import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery"

export const settingsApi = createApi({
    reducerPath: "settings",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['FAQs', 'Settings', 'Users', 'About', 'TAC', 'Privacy'],
    endpoints: (builder) => ({
        getFaqs: builder.query({
            query: ({ language, limit }) => ({
                url: `/settings/faqs?language=${language}&limit=${limit}`,
                method: "GET",
            }),
            providesTags: ['FAQs'],
        }),
        getTac: builder.query({
            query: ({ language }) => ({
                url: `/settings/terms-conditions?language=${language}`,
                method: "GET",
            }),
            providesTags: ['TAC'],
        }),
        getPrivacyPolicy: builder.query({
            query: ({ language }) => ({
                url: `/settings/privacy-policy?language=${language}`,
                method: "GET",
            }),
            providesTags: ['Privacy'],
        }),
        getAllFaqsByAdmin: builder.query({
            query: ({ page, keyword, limit, language }) => {
                let url = `/settings/faqs?page=${page + 1}`;
                if (keyword) {
                    url += `&keyword=${keyword}`;
                }
                if (limit) {
                    url += `&limit=${limit}`;
                }
                if (language) {
                    url += `&language=${language}`;
                }
                return {
                    url,
                    method: "GET",
                }
            },
            providesTags: ['FAQs'],
        }),
        addFaqByAdmin: builder.mutation({
            query: (data) => ({
                url: `/settings/faqs/`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ['FAQs'],
        }),
        deleteFaqByAdmin: builder.mutation({
            query: (id) => ({
                url: `/settings/faqs/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ['FAQs'],
        }),
        editFaqByAdmin: builder.mutation({
            query: ({ id, data }) => ({
                url: `/settings/faqs/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ['FAQs'],
        }),
        createsettingsByAdmin: builder.mutation({
            query: (data) => ({
                url: `/settings/create`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ['Settings'],
        }),
        editsettingByAdmin: builder.mutation({
            query: ({ id, data }) => ({
                url: `/settings/update/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ['Settings'],
        }),
        getAbout: builder.query({
            query: ({ language }) => ({
                url: `/settings/about-us?language=${language}`,
                method: "GET",
            }),
            providesTags: ['About'],
        }),
        updateSettings: builder.mutation({
            query: (id, data) => ({
                url: `/settings/update/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ['Settings'],
        }),
        getDashboardSettings: builder.query({
            query: ({ year }) => ({
                url: `/dashboard?year=${year}`,
                method: "GET",
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ['Settings'],
        }),
        getAdminDashboardSettings: builder.query({
            query: ({ year }) => ({
                url: `/dashboard/admin?year=${year}`,
                method: "GET",
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ['Settings'],
        }),
        getUsers: builder.query({
            query: ({ page, limit, keyword, status, userType }) => {
                let url = '/admin/all-users';
                if (page) {
                    url += `?page=${page}`;
                }
                if (limit) {
                    url += `&limit=${limit}`;
                }
                if (keyword) {
                    url += `&keyword=${keyword}`;
                }
                if (status) {
                    url += `&status=${status}`;
                }
                if (userType) {
                    url += `&userType=${userType}`;
                }
                return {
                    url,
                    method: "GET",
                };
            },
            transformResponse: (response) => ({
                data: response.data || [],
                meta: response.meta
            }),
            providesTags: ['Users'],
        }),
        updateUserProfileByAdmin: builder.mutation({
            query: ({ id, data }) => ({
                url: `/admin/users/${id}/account-state`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: ['Users'],
        }),
        publicGetAllUsers:builder.query({
            query:({id})=>({
                url:`/giveaway/${id}/winners-sample`,
            })
        })
    }),
});


export const {
    useGetFaqsQuery,
    useGetTacQuery,
    useGetPrivacyPolicyQuery,
    useUpdateSettingsMutation,
    useGetDashboardSettingsQuery,
    useGetAllFaqsByAdminQuery,
    useAddFaqByAdminMutation,
    useDeleteFaqByAdminMutation,
    useEditFaqByAdminMutation,
    useEditsettingByAdminMutation,
    useGetAboutQuery,
    useGetAdminDashboardSettingsQuery,
    useGetUsersQuery,
    useUpdateUserProfileByAdminMutation,
    useCreatesettingsByAdminMutation,
    usePublicGetAllUsersQuery
} = settingsApi;
